/* eslint-disable no-unused-vars */
import React, {useLayoutEffect, useState, useEffect} from 'react';
import {useMediaQuery} from 'react-responsive';
import {makeStyles} from '@material-ui/core/styles';
import Fab from '@material-ui/core/Fab';
import ArrowUpwardIcon from '@material-ui/icons/ArrowUpward';
import {FaBars} from 'react-icons/fa';
import CircularProgress from '@material-ui/core/CircularProgress';
import {Box} from '@material-ui/core';
import Button from '@material-ui/core/Button';
import {withStyles} from '@material-ui/core/styles';
import Checkbox from '@material-ui/core/Checkbox';
import DateFnsUtils from '@date-io/date-fns';
import {MuiPickersUtilsProvider} from '@material-ui/pickers';
import 'date-fns';
import deLocale from 'date-fns/locale/pt';
import {produce} from 'immer';
import './style.css';
import {useSelector} from 'react-redux';
import TextField from '@material-ui/core/TextField';
import AlertSending from '../../components/AlertSeding';
import * as ActionStore from '../../store/actions/setRestaurante';
import {useDispatch} from 'react-redux';
import {getAuth} from 'firebase/auth';

const useStyles = makeStyles(theme => ({
  formControl: {
    marginLeft: 10,
    minWidth: 120,
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
}));

const GreenCheckbox = withStyles({
  root: {
    color: '#C4C4C4',
    '&$checked': {
      color: '#06448E',
    },
  },
  checked: {},
})(props => <Checkbox color="default" {...props} />);

const ListWeek = ({
  DATA,
  isVerySmall,
  updateStatus,
  update2t,
  handleDateChange,
  handleDateChange2,
  handleDateChange3,
  handleDateChange4,
}) => {
  const classes = useStyles();
  let list = DATA.dtsm.map((item, index) => {
    return (
      <div
        key={'listweek' + index.toString()}
        style={{
          width: isVerySmall ? '100%' : 210,
          marginLeft: 10,
          marginRight: 10,
          marginTop: 20,
        }}
      >
        <Box
          boxShadow={3}
          style={{
            paddingLeft: 10,
            paddingRight: 10,
            borderRadius: 10,
            paddingBottom: 5,
            paddingTop: 5,
            backgroundColor: item.bopen ? '#ffffff' : '#ffffff',
          }}
        >
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'space-between',
            }}
          >
            <p style={{fontWeight: 'bold'}}>{item.day}</p>
            <div style={{display: 'flex', alignItems: 'center'}}>
              <GreenCheckbox
                onChange={() =>
                  updateStatus(index, !item.bopen, DATA.dtsm, 'sm')
                }
                checked={item.bopen}
                name={item.name}
              />
              <p style={{marginLeft: 0}}>Aberto</p>
            </div>
          </div>
          {item.bopen ? (
            <div style={{}}>
              <p style={{marginBottom: 0, marginTop: 0, fontWeight: 'bold'}}>
                1° Turno
              </p>
              <div
                style={{
                  backgroundColor: '#f4f4f4',
                  marginBottom: 10,
                  borderRadius: 3,
                  padding: 5,
                }}
              >
                <MuiPickersUtilsProvider locale={deLocale} utils={DateFnsUtils}>
                  <form className={classes.container} noValidate>
                    <TextField
                      style={{width: '100%'}}
                      id="time"
                      label="Abre ás"
                      type="time"
                      value={item.hr1a}
                      className={classes.textField}
                      onChange={e =>
                        handleDateChange(e.target.value, index, 'sm')
                      }
                      InputLabelProps={{
                        shrink: true,
                      }}
                      inputProps={{
                        step: 300, // 5 min
                      }}
                    />
                  </form>
                  <form className={classes.container} noValidate>
                    <TextField
                      style={{width: '100%', marginTop: 10}}
                      id="time"
                      label="Fecha ás"
                      type="time"
                      value={item.hr1f}
                      className={classes.textField}
                      onChange={e =>
                        handleDateChange2(e.target.value, index, 'sm')
                      }
                      InputLabelProps={{
                        shrink: true,
                      }}
                      inputProps={{
                        step: 300, // 5 min
                      }}
                    />
                  </form>
                </MuiPickersUtilsProvider>
              </div>
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  marginBottom: 0,
                  marginTop: 0,
                }}
              >
                <p style={{marginBottom: 0, marginTop: 0, fontWeight: 'bold'}}>
                  2° turno
                </p>
                <GreenCheckbox
                  onChange={() => update2t(index, !item.b2t, DATA.dtsm, 'sm')}
                  checked={item.b2t}
                  name={item.name}
                />
              </div>
              {item.b2t ? (
                <div
                  style={{
                    backgroundColor: '#f4f4f4',
                    marginBottom: 10,
                    borderRadius: 3,
                    padding: 5,
                  }}
                >
                  <MuiPickersUtilsProvider
                    locale={deLocale}
                    utils={DateFnsUtils}
                  >
                    <form className={classes.container} noValidate>
                      <TextField
                        style={{width: '100%'}}
                        id="time"
                        label="Abre ás"
                        type="time"
                        value={item.hr2a}
                        className={classes.textField}
                        onChange={e =>
                          handleDateChange3(e.target.value, index, 'sm')
                        }
                        InputLabelProps={{
                          shrink: true,
                        }}
                        inputProps={{
                          step: 300, // 5 min
                        }}
                      />
                    </form>
                    <form className={classes.container} noValidate>
                      <TextField
                        style={{width: '100%', marginTop: 10}}
                        id="time"
                        label="Fecha ás"
                        type="time"
                        value={item.hr2f}
                        className={classes.textField}
                        onChange={e =>
                          handleDateChange4(e.target.value, index, 'sm')
                        }
                        InputLabelProps={{
                          shrink: true,
                        }}
                        inputProps={{
                          step: 300, // 5 min
                        }}
                      />
                    </form>
                  </MuiPickersUtilsProvider>
                </div>
              ) : null}
            </div>
          ) : (
            <div
              style={{
                backgroundColor: '#FFE7E7',
                paddingLeft: 5,
                paddingTop: 1,
                paddingBottom: 1,
                borderRadius: 3,
              }}
            >
              <p style={{color: '#FF0000', textAlign: 'center'}}>Fechado</p>
            </div>
          )}
        </Box>
      </div>
    );
  });

  return list;
};

const ListWeekend = ({
  DATA,
  isVerySmall,
  updateStatus,
  update2t,
  handleDateChange,
  handleDateChange2,
  handleDateChange3,
  handleDateChange4,
}) => {
  const classes = useStyles();
  let list = DATA.dtfds.map((item, index) => {
    return (
      <div
        key={'listweekend' + index.toString()}
        style={{
          width: isVerySmall ? '100%' : 270,
          marginLeft: 10,
          marginRight: 10,
          marginTop: 20,
        }}
      >
        <Box
          boxShadow={3}
          style={{
            paddingLeft: 10,
            paddingRight: 10,
            borderRadius: 10,
            paddingBottom: 5,
            paddingTop: 5,
            backgroundColor: item.bopen ? '#ffffff' : '#FFFFFF',
          }}
        >
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'space-between',
            }}
          >
            <p style={{fontWeight: 'bold'}}>{item.day}</p>
            <div style={{display: 'flex', alignItems: 'center'}}>
              <GreenCheckbox
                onChange={() =>
                  updateStatus(index, !item.bopen, DATA.dtfds, 'fds')
                }
                checked={item.bopen}
                name={item.name}
              />
              <p style={{marginLeft: 0}}>Aberto</p>
            </div>
          </div>
          {item.bopen ? (
            <div style={{}}>
              <p style={{marginBottom: 0, marginTop: 0, fontWeight: 'bold'}}>
                1° Turno
              </p>
              <div
                style={{
                  backgroundColor: '#f4f4f4',
                  marginBottom: 10,
                  borderRadius: 3,
                  padding: 5,
                }}
              >
                <MuiPickersUtilsProvider locale={deLocale} utils={DateFnsUtils}>
                  <form className={classes.container} noValidate>
                    <TextField
                      style={{width: '100%'}}
                      id="time"
                      label="Abre ás"
                      type="time"
                      value={item.hr1a}
                      className={classes.textField}
                      onChange={e =>
                        handleDateChange(e.target.value, index, 'fds')
                      }
                      InputLabelProps={{
                        shrink: true,
                      }}
                      inputProps={{
                        step: 300, // 5 min
                      }}
                    />
                  </form>
                  <form className={classes.container} noValidate>
                    <TextField
                      style={{width: '100%', marginTop: 10}}
                      id="time"
                      label="Fecha ás"
                      type="time"
                      value={item.hr1f}
                      className={classes.textField}
                      onChange={e =>
                        handleDateChange2(e.target.value, index, 'fds')
                      }
                      InputLabelProps={{
                        shrink: true,
                      }}
                      inputProps={{
                        step: 300, // 5 min
                      }}
                    />
                  </form>
                </MuiPickersUtilsProvider>
              </div>
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  marginBottom: 0,
                  marginTop: 0,
                }}
              >
                <p style={{marginBottom: 0, marginTop: 0, fontWeight: 'bold'}}>
                  2° turno
                </p>
                <GreenCheckbox
                  onChange={() => update2t(index, !item.b2t, DATA.dtfds, 'fds')}
                  checked={item.b2t}
                  name={item.name}
                />
              </div>
              {item.b2t ? (
                <div
                  style={{
                    backgroundColor: '#f4f4f4',
                    marginBottom: 10,
                    borderRadius: 3,
                    padding: 5,
                  }}
                >
                  <MuiPickersUtilsProvider
                    locale={deLocale}
                    utils={DateFnsUtils}
                  >
                    <form className={classes.container} noValidate>
                      <TextField
                        style={{width: '100%'}}
                        id="time"
                        label="Abre ás"
                        type="time"
                        value={item.hr2a}
                        className={classes.textField}
                        onChange={e =>
                          handleDateChange3(e.target.value, index, 'fds')
                        }
                        InputLabelProps={{
                          shrink: true,
                        }}
                        inputProps={{
                          step: 300, // 5 min
                        }}
                      />
                    </form>
                    <form className={classes.container} noValidate>
                      <TextField
                        style={{width: '100%', marginTop: 10}}
                        id="time"
                        label="Fecha ás"
                        type="time"
                        value={item.hr2f}
                        className={classes.textField}
                        onChange={e =>
                          handleDateChange4(e.target.value, index, 'fds')
                        }
                        InputLabelProps={{
                          shrink: true,
                        }}
                        inputProps={{
                          step: 300, // 5 min
                        }}
                      />
                    </form>
                  </MuiPickersUtilsProvider>
                </div>
              ) : null}
            </div>
          ) : (
            <div
              style={{
                backgroundColor: '#FFE7E7',
                paddingLeft: 5,
                paddingTop: 1,
                paddingBottom: 1,
                borderRadius: 3,
              }}
            >
              <p style={{color: '#FF0000', textAlign: 'center'}}>Fechado</p>
            </div>
          )}
        </Box>
      </div>
    );
  });

  return list;
};

// eslint-disable-next-line react/prop-types
const Horarios = ({handleToggleSidebar, handleNotiStack, handleBackDrop}) => {
  const auth = getAuth();
  const isSmall = useMediaQuery({query: '(max-width: 750.98px)'});
  const isVerySmall = useMediaQuery({query: '(max-width:450.00px)'});
  const [isLoading, setLoading] = useState(true);
  const sdtsm = useSelector(state => state.setrestaurante.dtsm);
  const sdtfds = useSelector(state => state.setrestaurante.dtfds);
  const estado = useSelector(state => state.setrestaurante);
  const dispatch = useDispatch();
  const docid = useSelector(state => state.setrestaurante.id);
  // The first commit of Material-UI
  // eslint-disable-next-line no-unused-vars
  const [selectedDate, setSelectedDate] = React.useState(new Date());

  function handleDateChange(date, index, list) {
    if (list === 'fds') {
      setDATA(currentItem =>
        produce(currentItem, v => {
          v.dtfds[index].hr1a = date;
        }),
      );
    } else {
      setDATA(currentItem =>
        produce(currentItem, v => {
          v.dtsm[index].hr1a = date;
        }),
      );
    }
  }

  function handleDateChange2(date, index, list) {
    if (list === 'fds') {
      setDATA(currentItem =>
        produce(currentItem, v => {
          v.dtfds[index].hr1f = date.toString();
        }),
      );
    } else {
      setDATA(currentItem =>
        produce(currentItem, v => {
          v.dtsm[index].hr1f = date.toString();
        }),
      );
    }
  }

  function handleDateChange3(date, index, list) {
    if (list === 'fds') {
      setDATA(currentItem =>
        produce(currentItem, v => {
          v.dtfds[index].hr2a = date.toString();
        }),
      );
    } else {
      setDATA(currentItem =>
        produce(currentItem, v => {
          v.dtsm[index].hr2a = date.toString();
        }),
      );
    }
  }

  function handleDateChange4(date, index, list) {
    if (list === 'fds') {
      setDATA(currentItem =>
        produce(currentItem, v => {
          v.dtfds[index].hr2f = date.toString();
        }),
      );
    } else {
      setDATA(currentItem =>
        produce(currentItem, v => {
          v.dtsm[index].hr2f = date.toString();
        }),
      );
    }
  }

  useEffect(() => {
    setDATA({
      dtsm: sdtsm,
      dtfds: sdtfds,
    });
    setTimeout(() => {
      setLoading(false);
    }, 1000);
  }, [estado]);

  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    // Button is displayed after scrolling for 500 pixels
    const toggleVisibility = () => {
      if (window.pageYOffset > 50) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener('scroll', toggleVisibility);

    return () => window.removeEventListener('scroll', toggleVisibility);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  function useWindowSize() {
    const [size, setSize] = useState([0, 0]);
    useLayoutEffect(() => {
      function updateSize() {
        setSize([window.innerWidth, window.innerHeight]);
      }
      window.addEventListener('resize', updateSize);
      updateSize();
      return () => window.removeEventListener('resize', updateSize);
    }, []);
    return size;
  }
  const [width, height] = useWindowSize();

  const [DATA, setDATA] = useState({
    dtsm: [
      {
        day: 'Segundas',
        bopen: true,
        hr1a: '00:00',
        hr1f: '00:00',
        b2t: true,
        hr2a: '18:30',
        hr2f: '21:30',
      },
      {
        day: 'Terças',
        bopen: false,
        hr1a: '00:00',
        hr1f: '00:00',
        b2t: true,
        hr2a: '00:00',
        hr2f: '00:00',
      },
      {
        day: 'Quartas',
        bopen: true,
        hr1a: '00:00',
        hr1f: '00:00',
        b2t: true,
        hr2a: '00:00',
        hr2f: '00:00',
      },
      {
        day: 'Quintas',
        bopen: true,
        hr1a: '00:00',
        hr1f: '00:00',
        b2t: true,
        hr2a: '00:00',
        hr2f: '00:00',
      },
    ],
    dtfds: [
      {
        day: 'Sextas',
        bopen: true,
        hr1a: '00:00',
        hr1f: '00:00',
        b2t: true,
        hr2a: '00:00',
        hr2f: '00:00',
      },
      {
        day: 'Sabados',
        bopen: false,
        hr1a: '00:00',
        hr1f: '00:00',
        b2t: true,
        hr2a: '00:00',
        hr2f: '00:00',
      },
      {
        day: 'Domingos',
        bopen: true,
        hr1a: '00:00',
        hr1f: '00:00',
        b2t: true,
        hr2a: '00:00',
        hr2f: '00:00',
      },
    ],
  });

  function updateStatus(ind, value, list, sec) {
    let data = list.map((item, index) => {
      if (ind === index) {
        return {...item, bopen: value};
      } else {
        return item;
      }
    });

    if (sec === 'fds') {
      setDATA({...DATA, dtfds: data});
    } else {
      setDATA({...DATA, dtsm: data});
    }
  }

  function update2t(ind, value, list, sec) {
    let data = list.map((item, index) => {
      if (ind === index) {
        return {...item, b2t: value};
      } else {
        return item;
      }
    });

    if (sec === 'fds') {
      setDATA({...DATA, dtfds: data});
    } else {
      setDATA({...DATA, dtsm: data});
    }
  }

  function updateHour(ind, value, list, sec) {
    let data = list.map((item, index) => {
      if (ind === index) {
        return {...item, bopen: value};
      } else {
        return item;
      }
    });

    if (sec === 'fds') {
      setDATA({...DATA, dtfds: data});
    } else {
      setDATA({...DATA, dtsm: data});
    }
  }

  const [isSending, setIsSending] = useState(false);
  function onSave() {
    setIsSending(true);
    let chckfds = DATA.dtfds.map((item, index) => {
      if (item.bopen) {
        if (item.hr1a > item.hr1f || item.hr2a > item.hr2f) {
          return true;
        } else {
          return true;
        }
      } else {
        return true;
      }
    });

    let chcksm = DATA.dtsm.map((item, index) => {
      if (item.bopen) {
        if (item.hr1a > item.hr1f || item.hr2a > item.hr2f) {
          return true;
        } else {
          return true;
        }
      } else {
        return true;
      }
    });

    let checker = arr => arr.every(v => v === true);
    if (checker(chckfds) && checker(chcksm)) {
      auth.currentUser.getIdToken().then(token => {
        const request = new Request(
          'https://kops.apiireit.com/gateway/store/update/opentime/' + docid,
          {
            method: 'PUT',
            mode: 'cors',
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify([DATA.dtfds, DATA.dtsm]),
          },
        );

        fetch(request)
          .then(response => {
            if (response.status === 200) {
              handleBackDrop('', '', 200, false);
              response
                .json()
                .then(data => {
                  setTimeout(() => {
                    setIsSending(false);
                    handleNotiStack(
                      'Horários atualizados com sucesso',
                      'success',
                    );
                  }, 1000);
                  dispatch(
                    ActionStore.setrestaurante(
                      data._id,
                      data.nome,
                      data.dsc,
                      data.nota,
                      data.nNotas,
                      data.cat,
                      data.entrg,
                      data.rtrda,
                      data.agdnt,
                      data.espra,
                      data.dsct,
                      data.frete,
                      data.nAv,
                      data.pdmin,
                      data.entgrts,
                      data.location,
                      data.img,
                      data.stt,
                      data.catprice,
                      data.iient,
                      data.chck,
                      data.merc,
                      data.cpm,
                      data.promoent,
                      data.bapp,
                      data.bpix,
                      data.bame,
                      data.bpicpay,
                      data.bmp,
                      data.bpaypal,
                      data.bpre,
                      data.bvir,
                      data.bvref,
                      data.bd,
                      data.bvd,
                      data.bmcd,
                      data.belod,
                      data.bhipd,
                      data.bdind,
                      data.baled,
                      data.bsood,
                      data.bvrd,
                      data.bbend,
                      data.bdisd,
                      data.btrid,
                      data.bbnsd,
                      data.bbrsd,
                      data.bbrd,
                      data.bvc,
                      data.bmcc,
                      data.beloc,
                      data.bhipc,
                      data.bdinc,
                      data.balec,
                      data.bsodc,
                      data.bvrc,
                      data.bbenc,
                      data.bdisc,
                      data.btric,
                      data.bbnsc,
                      data.bbrsc,
                      data.bbrc,
                      data.end,
                      data.num,
                      data.bairro,
                      data.cid,
                      data.est,
                      data.cnpj,
                      data.bodom,
                      data.hdom,
                      data.boseg,
                      data.hseg,
                      data.boter,
                      data.hter,
                      data.boqua,
                      data.hqua,
                      data.boqui,
                      data.hqui,
                      data.bosex,
                      data.hsex,
                      data.bosab,
                      data.hsab,
                      data.aratdm,
                      data.raio,
                      data.bdstc,
                      data.essm,
                      data.esfds,
                      data.inalta,
                      data.npd,
                      data.znid,
                      data.zntx,
                      data.iitx,
                      data.iietx,
                      data.freetx,
                      data.freetill,
                      data.lastSeenAt,
                      data.presence,
                      data.openchat,
                      data.agd,
                      data.fagdays,
                      data.dtsm,
                      data.dtfds,
                      data.ctto,
                      data.aratdmii,
                      data.mxprmetrg,
                      data.bbank,
                      data.btcnta,
                      data.bagcia,
                      data.bcnta,
                      data.bdig,
                      data.cpix,
                      data.npix,
                      data.nimg,
                      data.comp,
                      data.cep,
                      data.ctrt,
                      data.hrCtrt,
                      data.bckentii,
                      data.fretes,
                    ),
                  );
                })
                .catch(error => {
                  console.error(error);
                });
            } else if (response.status === 503) {
              setIsSending(false);
              setTimeout(() => {
                handleNotiStack(
                  'Não foi possível salvar as informações',
                  'error',
                );
              }, 1000);
              handleBackDrop(
                'Serviço indisponível no momento',
                'O serviços para as lojas Irê it não estão disponíveis no momento. Por favor, tente novamente mais tarde',
                503,
                true,
              );
              throw new Error('Something went wrong on API server!');
            } else if (response.status === 404) {
              setIsSending(false);
              setTimeout(() => {
                handleNotiStack(
                  'Não foi possível salvar as informações',
                  'error',
                );
              }, 1000);
              handleBackDrop(
                'Serviço não encontrado.',
                'Por favor, entre em contato com o nosso suporte e relate o problema.',
                404,
                true,
              );
            } else if (response.status === 401) {
              setIsSending(false);
              setTimeout(() => {
                handleNotiStack(
                  'Não foi possível salvar as informações',
                  'error',
                );
              }, 1000);
              handleBackDrop(
                'Você não possui autorização ou suas credenciais expirarão.',
                'Por favor, atualize a baixa ou refaça o processo dee login.',
                401,
                true,
              );
            } else if (response.status === 400) {
              setIsSending(false);
              setTimeout(() => {
                handleNotiStack(
                  'Não foi possível salvar as informações',
                  'error',
                );
              }, 1000);
              handleBackDrop(
                'Requisição inválida.',
                'Confira se todos os campos estão preenchidos corretamente.',
                400,
                true,
              );
            } else if (response.status === 500) {
              setIsSending(false);
              setTimeout(() => {
                handleNotiStack(
                  'Não foi possível salvar as informações',
                  'error',
                );
              }, 1000);
              handleBackDrop(
                'Nosso servidor está passando por irregularidades.',
                'Estamos trabalhado para resolver o mais rápido possível.',
                500,
                true,
              );
            }
          })
          .catch(error => {
            setIsSending(false);
            setTimeout(() => {
              handleNotiStack(
                'Não foi possível salvar as informações',
                'error',
              );
            }, 1000);
            handleBackDrop(
              'Nosso servidor está passando por irregularidades.',
              'Estamos trabalhado para resolver o mais rápido possível.',
              500,
              true,
            );
            console.error(error);
          });
      });
    } else {
      setIsSending(false);
      handleNotiStack(
        'Verifique se tem pelo menos um dia aberto e se alguma tempo de espera mínimo está maior que o máximo',
        'error',
      );
    }
  }

  return (
    <div>
      {isLoading ? (
        <div
          style={{
            display: 'flex',
            flex: 1,
            alignItems: 'center',
            justifyContent: 'center',
            height: height,
          }}
        >
          <CircularProgress />
        </div>
      ) : (
        <div>
          {isVisible ? (
            <Fab
              onClick={() => scrollToTop()}
              style={{position: 'fixed', bottom: 20, right: 20, zIndex: 2}}
              size={'small'}
              color="primary"
              aria-label="add"
            >
              <ArrowUpwardIcon />
            </Fab>
          ) : null}
          <div
            style={{marginLeft: 10, marginTop: 10}}
            className="btn-toggle"
            onClick={() => handleToggleSidebar(true)}
          >
            <FaBars />
          </div>
          {isVerySmall || isSmall ? (
            <div style={{marginLeft: 10, marginRight: 10}}>
              <h1>Horários</h1>
              <Button
                onClick={() => onSave()}
                style={{marginLeft: 0, marginTop: 0, marginBottom: 0}}
                variant="contained"
                size={'medium'}
                color="primary"
              >
                Salvar
              </Button>
              <div
                style={{flexWrap: 'wrap', display: 'flex', marginBottom: 10}}
              >
                <ListWeekend
                  DATA={DATA}
                  isVerySmall={isVerySmall}
                  updateStatus={updateStatus}
                  update2t={update2t}
                  handleDateChange={handleDateChange}
                  handleDateChange2={handleDateChange2}
                  handleDateChange3={handleDateChange3}
                  handleDateChange4={handleDateChange4}
                />
              </div>
              <div
                style={{flexWrap: 'wrap', display: 'flex', marginBottom: 30}}
              >
                <ListWeek
                  DATA={DATA}
                  isVerySmall={isVerySmall}
                  updateStatus={updateStatus}
                  update2t={update2t}
                  handleDateChange={handleDateChange}
                  handleDateChange2={handleDateChange2}
                  handleDateChange3={handleDateChange3}
                  handleDateChange4={handleDateChange4}
                />
              </div>
              <Button
                onClick={() => onSave()}
                style={{marginLeft: 0, marginTop: 10, marginBottom: 40}}
                variant="contained"
                size={'medium'}
                color="primary"
              >
                Salvar
              </Button>
            </div>
          ) : (
            <div style={{marginLeft: 10, marginRight: 10}}>
              <h1>Horários</h1>
              <Button
                onClick={() => onSave()}
                style={{marginLeft: 0, marginTop: 0, marginBottom: 0}}
                variant="contained"
                size={'medium'}
                color="primary"
              >
                Salvar
              </Button>
              <div
                style={{flexWrap: 'wrap', display: 'flex', marginBottom: 10}}
              >
                <ListWeekend
                  DATA={DATA}
                  isVerySmall={isVerySmall}
                  updateStatus={updateStatus}
                  update2t={update2t}
                  handleDateChange={handleDateChange}
                  handleDateChange2={handleDateChange2}
                  handleDateChange3={handleDateChange3}
                  handleDateChange4={handleDateChange4}
                />
              </div>
              <div
                style={{flexWrap: 'wrap', display: 'flex', marginBottom: 30}}
              >
                <ListWeek
                  DATA={DATA}
                  isVerySmall={isVerySmall}
                  updateStatus={updateStatus}
                  update2t={update2t}
                  handleDateChange={handleDateChange}
                  handleDateChange2={handleDateChange2}
                  handleDateChange3={handleDateChange3}
                  handleDateChange4={handleDateChange4}
                />
              </div>
              <Button
                onClick={() => onSave()}
                style={{marginLeft: 0, marginTop: 10, marginBottom: 40}}
                variant="contained"
                size={'medium'}
                color="primary"
              >
                Salvar
              </Button>
            </div>
          )}
        </div>
      )}
      <AlertSending
        bopen={isSending}
        handleClose={() => setIsSending(false)}
        handleNotiStack
        style={{
          top: 0,
          position: 'absolute',
          zIndex: 3,
        }}
      />
    </div>
  );
};

export default Horarios;
